/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * Generated with the TypeScript template
 * https://github.com/react-native-community/react-native-template-typescript
 *
 * @format
 */
import React from 'react';
import {UserProvider} from './context/user';

import Main from './Main';

import {LogBox} from 'react-native';

LogBox.ignoreLogs(["EventEmitter.removeListener('appStateDidChange', ...)"]);

const App = () => {
  return (
    <UserProvider>
      <Main />
    </UserProvider>
  );
};
export default App;
